// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");

function NotificationTypeIcon(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("div", {
                                children: props.children,
                                className: "ml-[2px]"
                              }),
                          className: "absolute inset-0 flex w-full h-full rounded-full border border-zinc-300 justify-center items-center text-[30px] text-tan-blue-500"
                        }),
                    className: "w-full pb-[100%] relative"
                  }),
              className: "block shrink-0 w-10 relative sm:w-[50px]"
            });
}

var make = NotificationTypeIcon;

exports.make = make;
/* react/jsx-runtime Not a pure module */
